import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import {
  GET_WEBHOOK_TYPES_SUCCESS,
  GetMsisdnsForWebhooksAction,
  GetWebhookTypesAction
} from 'app/webhooks/webhooks.actions';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { take } from 'rxjs/operators';

@Injectable()
export class WebhookTypesResolver implements Resolve<any> {
  constructor(private store: Store<any>, private action$: Actions) {}

  resolve() {
    this.store.dispatch(new GetMsisdnsForWebhooksAction());
    this.store.dispatch(new GetWebhookTypesAction());
    return this.action$.pipe(ofType(GET_WEBHOOK_TYPES_SUCCESS), take(1));
  }
}
